/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $Container, ContainerProps, CanBeSignal} from '@gongxigames/framework/core/fragments/BuilderY';
import {$Checkbox} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/Checkbox';
import {$UIText} from '../../../JSX/UIText';

type AutoplayOptionsSelectorEntryProps = {
    value: CanBeSignal<boolean>;
    disabled?: CanBeSignal<boolean>;
    action: CanBeSignal<(value: boolean) => void>;
};

export type $AutoplayOptionsSelectorProps = ContainerProps & {
    quickSpin: AutoplayOptionsSelectorEntryProps;
    turboSpin: AutoplayOptionsSelectorEntryProps;
    untilBonus: AutoplayOptionsSelectorEntryProps;
};

const OptionComponent: FC<AutoplayOptionsSelectorEntryProps & ContainerProps> = (props) => {
    return <$Container
        {...props}
    >
        <$Checkbox position={[220, 0]} value={props.value} action={props.action}/>
        <$UIText
            localeID={props.name}
            stylePreset='POPUP_TEXT'
            style={{align: 'left'}}
            position={[342, 0]}
            maxWidth={560}
        />
    </$Container>;
};

export const $AutoplayOptionsSelector: FC<$AutoplayOptionsSelectorProps> = (props) => {
    const {responsive, quickSpin, turboSpin, untilBonus} = props;

    return <$Container
        responsive={responsive}
    >
        <OptionComponent name='quickSpin' position={[0, 0]} {...quickSpin}/>
        <OptionComponent name='turboSpin' position={[0, 140]} {...turboSpin}/>
        <OptionComponent name='untilBonus' position={[0, 2 * 140]} {...untilBonus}/>
    </$Container>;
};
